module.exports = __webpack_public_path__ + "img/EducationalGroupStudents.bb105945.svg";